import { GoogleOAuthProvider } from '@react-oauth/google';
import { ReactNode } from 'react';

interface GoogleAuthProviderProps {
  children: ReactNode;
}

/**
 * Google OAuth Provider wrapper component
 * Wraps the application with Google OAuth configuration
 */
export const GoogleAuthProviderWrapper = ({ children }: GoogleAuthProviderProps) => {
  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

  // Always wrap with provider to avoid context errors
  // If no valid client ID, the Google button won't work but won't crash
  return <GoogleOAuthProvider clientId={clientId || 'placeholder'}>{children}</GoogleOAuthProvider>;
};
